module.exports = __webpack_public_path__ + "front/img/sub-img-4-wap.11107d08.png";